import { ButtonPrimaryTextOnly, Tooltip, Typography } from '@creditas-ui/react'
import React from 'react'
import { useInspectionLink } from 'shared/application/hooks/useInspectionLink'
import { CheckIcon, CopyIcon, Loading } from 'shared/ui'
import {
  FeedAction,
  FeedbackInspection,
  InspectionUrl,
  LinkInspection,
  WrapperError,
  WrapperIcon,
  WrapperInspectionUrl,
  WrapperLoading,
} from './Inspection.styles'

const resolveTooltipText = (bool = false) => {
  const TextCopied = 'Link copiado'
  const CopyLink = 'Copiar link'
  return bool ? TextCopied : CopyLink
}

const resolveDataTestIdText = (bool = false) => {
  const TextCopied = 'checkIcon'
  const CopyLink = 'copyIcon'
  return bool ? TextCopied : CopyLink
}

export const InspectionLink = ({ type, idProposal }) => {
  const {
    fetchData,
    link,
    error,
    loading,
    inspectionLinkCopied,
    copyLinkClipboard,
  } = useInspectionLink(idProposal)

  return (
    <>
      {link && type !== 'button' ? (
        <WrapperInspectionUrl>
          <InspectionUrl>{link}</InspectionUrl>
          <Tooltip
            content={resolveTooltipText(inspectionLinkCopied)}
            local="right"
            variant="dark"
          >
            <WrapperIcon
              onClick={() => copyLinkClipboard(link)}
              data-testid={resolveDataTestIdText(inspectionLinkCopied)}
            >
              {inspectionLinkCopied ? (
                <CheckIcon width="24px" height="24px" />
              ) : (
                <CopyIcon />
              )}
            </WrapperIcon>
          </Tooltip>
        </WrapperInspectionUrl>
      ) : type === 'button' ? (
        <LinkInspection>
          <ButtonPrimaryTextOnly
            onClick={fetchData}
            loading={loading}
            size="small"
            width="flexible"
          >
            Copiar link de vistoria
          </ButtonPrimaryTextOnly>
          {link && (
            <FeedbackInspection>
              <Typography
                color="neutral.10"
                component="h2"
                variant="bodyXsRegular"
              >
                {resolveTooltipText(inspectionLinkCopied)}
              </Typography>
            </FeedbackInspection>
          )}
        </LinkInspection>
      ) : (
        <FeedAction onClick={fetchData}>
          Obter link da vistoria{' '}
          {loading && (
            <WrapperLoading>
              <Loading />
            </WrapperLoading>
          )}
        </FeedAction>
      )}
      {error && (
        <WrapperError>
          <Typography
            color="error.60"
            alignText={type === 'button' ? 'left' : 'right'}
            component="p"
            variant="bodySmRegular"
          >
            Ocorreu um erro ao recuperar o link, tente novamente.
          </Typography>
        </WrapperError>
      )}
    </>
  )
}
